import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppUserClaimsService } from '../../../../../core/services/app-user-claims.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-contact-center-remove-dialog',
  templateUrl: './contact-center-remove-dialog.component.html',
  styleUrls: ['./contact-center-remove-dialog.component.scss'],
})

export class ContactCenterRemoveDialogComponent implements OnInit {
	removeUrl: string = undefined;
	fullUrl: string = undefined;
	extraParams: string = 'remove=true';
	deleteInProgress: boolean = false;
	deleteNotComplete: boolean = false;
	removeClientId: string = environment.callCenterSpa.clientId;
    productCode: string = '';

	@HostListener('window:message', ['$event'])
	onMessage(event) {
		console.log('CC - iframe child sending messages', event);
		if (event && event.data && event.data.message === 'cx-next-quick-setup-cancelled') {
			this.sendChildUnloadMessage();
			this.onDone();
		} 
		else if (event && event.data && event.data.message === 'cx-next-quick-setup-finished') {
			this.sendChildUnloadMessage();
			this.dialogRef.close(true);
		} 
		// not sure if this is going to be needed, in a state of change
		// else if (event && event.data && event.data.message === 'cx-next-quick-setup-error') {
		// 	this.sendChildUnloadMessage();
		// 	this.deleteInProgress = false;
		// 	this.deleteNotComplete = true;
		// } 
	}

	constructor( @Inject(MAT_DIALOG_DATA) public data: any,
				public dialogRef: MatDialogRef<ContactCenterRemoveDialogComponent>,
				private translateService: TranslateService,
				private appClaimsService: AppUserClaimsService ) 
	{
		this.productCode = data.product.productCode;
	}

	showFormError: boolean = false;
	errMsg: string = "";
	errMsgStyle: any = { 'max-width': '500px' };

	ngOnInit() 
	{
		//await this.determineInitalDialogState( this.data.account );
		this.beginRemoveProcess();

	}

	onDone()
	{
		this.sendChildUnloadMessage();
		this.dialogRef.close(false);
	}

	onRetry(event)
	{
		//TBD if this is really needed
	}
	

	// to prevent a circular dependency
	sendChildUnloadMessage()
	{
		var iframeSpa= (<HTMLIFrameElement>document.getElementById("iframeSpa"));

		if ( iframeSpa && iframeSpa.contentWindow )
		{
			console.log("Sending an CL_UNLOAD to the child iframe")
			iframeSpa.contentWindow.postMessage("CL_UNLOAD", '*');
		}
			
	}

	beginRemoveProcess()
	{
		let baseUrl:string;
/* istanbul ignore next */ // this is for dev/ debug purposes
		if ( window.location.href.indexOf('-stage.dev.') > 0 )
		{
		  baseUrl = environment.callCenterSpa.callCentreStageDevBaseURL;
		}
		else
		{
			baseUrl = environment.callCenterSpa.callCentreBaseURL;
		}

		this.removeUrl = baseUrl; 

		if (this.productCode === 'VoiceAssist')
			this.fullUrl = baseUrl + '/embed/setupVoiceAssist/';
		else
			this.fullUrl = baseUrl + '/embed/setup/';

		this.deleteInProgress = true;
	}
}
